export const visionMoviePlaceholderData = {
  visionMovie: [],
  archive: [{ id: "archivePlaceholder" }],
  backgroundMusic: null,
};
